/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import OptionInput from './OptionInput';


const QuestionChoiceOptions = ({
  options, onDelete, onChange, onDragEnd, multiple, editMode,
}) => (
  <DragDropContext onDragEnd={onDragEnd}>
    <Droppable droppableId="options-list">
      {provided => (
        <div
          {...provided.droppableProps}
          ref={provided.innerRef}
        >
          {options.map((opt, i) => (
            <OptionInput
              key={opt.id}
              id={opt.id}
              index={i}
              value={opt.name}
              onDelete={onDelete}
              onChange={onChange}
              multiple={multiple}
              editMode={editMode}
            />
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  </DragDropContext>
);


QuestionChoiceOptions.propTypes = {
  options: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  multiple: PropTypes.bool.isRequired,
  editMode: PropTypes.bool.isRequired,
};

export default QuestionChoiceOptions;
